import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { useSelector } from 'react-redux'

import { useUpgradeSubscription } from 'components/billing/use_upgrade_subscription'
import { isAvailableFeatureSelector } from 'features/billing'
import { useETEditorFormikPoolingType } from 'services/event_types'

import { AddButton } from './add_button'
import { HostPicker } from './host_picker'
import { getPrepareHostOptionProps } from '../helpers'
import { useAddCollectiveHosts, useAddRoundRobinHosts, useUserPoolsData } from '../hooks'

export const AddHostButton = ({
  children,
  eventType,
  userPoolUid,
  isOpenByDefault = false,
  isAddingRotatingHosts = false,
}) => {
  const [toggleDropdown, Dropdown] = useDropdown(isOpenByDefault)

  const isCollectiveRoundRobinFeatureAvailable = useSelector(
    (state) => isAvailableFeatureSelector(state, { featureKey: 'collective_round_robin_event_types' })
  )

  const { values: { memberships }, isSubmitting } = useFormContext()
  const { isCollective, isRoundRobin, isCollectiveRoundRobin, isMultiHost } = useETEditorFormikPoolingType()
  const { collectiveUserPoolUid } = useUserPoolsData()
  const { isTeam } = eventType

  const upgradeSubscription = useUpgradeSubscription({ featureKey: 'collective_round_robin_event_types' })
  const onAddCollectiveHosts = useAddCollectiveHosts(eventType)
  const onAddRoundRobinHosts = useAddRoundRobinHosts(eventType)

  if (!isMultiHost) return null

  const handleAddHosts = (eventTypeMemberships) => {
    toggleDropdown()
    if (!isCollectiveRoundRobinFeatureAvailable && !isCollective) return upgradeSubscription()

    if (isAddingRotatingHosts) {
      return onAddRoundRobinHosts(eventTypeMemberships, userPoolUid)
    }

    return onAddCollectiveHosts(eventTypeMemberships, userPoolUid)
  }

  return (
    <>
      <AddButton onClick={toggleDropdown} disabled={isSubmitting}>
        {children}
      </AddButton>
      <Dropdown>
        <HostPicker
          isAddingRotatingHosts
          isMultiSelect
          isDisabled={isSubmitting}
          memberships={memberships}
          onClose={toggleDropdown}
          onSelect={handleAddHosts}
          placeholder={I18n.t('publisher.event_type_editor.sections.hosts.picker.placeholder.search_hosts')}
          prepareHostOptionProps={getPrepareHostOptionProps({
            memberships,
            isTeam,
            isCollective,
            isRoundRobin,
            isCollectiveRoundRobin,
            isAddingRotatingHosts,
            userPoolUid,
            collectiveUserPoolUid
          })}
          skipSearch={isTeam}
        />
      </Dropdown>
    </>
  )
}
